import React from "react";
import { CGE } from "../../../../common/components/CGE";
import Loading from "../../../../common/components/Loading";
import { decode_utf8, changeCurrancyFormat } from "../../../../common/utils/utilsFunc";
import FormVoluntaryCollectiveProcedureContextProvider, {
    FormVoluntaryCollectiveProcedureContext,
    ACTIONS
} from "../../context/FormVoluntaryCollectiveProcedureContextProvider";
import "../../styles/index.scss";
import { useModal } from "@clayui/modal";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

const FormVoluntaryCollectiveProcedure = ({ props }) => {
    const [state, dispatch] = React.useContext(FormVoluntaryCollectiveProcedureContext);
    const [loading, setLoading] = React.useState(false);
    const [errorNumCli, setErrorNumCli] = React.useState("");
    const [numCli, setNumCli] = React.useState(false);
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [detailShow, setDetailsShow] = React.useState(false);
    const [detailClientJson, setDetailClientJson] = React.useState([]);
    const [visibleModal, setVisibleModal] = React.useState(false);
    const [dealInfo, setDealInfo] = React.useState(null);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    let propsLabelInfoContent = {
        "content": state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal,
        "titleHint": "Ayuda Nro de Cliente",
    }

    function onChangeReCaptcha(value) {
        updateCookieState(value);

        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function handleClick() {
        setErrorNumCli(false);
        if (numCli && verifReCaptcha) {
            setLoading(true);
            setDetailClientJson([]);
            setDetailsShow([]);
            dispatch({
                payload: numCli,
                type: ACTIONS.SET_SERV1,
            });
        } else if (!numCli) {
            setErrorNumCli(true);
            props.setGlobalAlert("Debes ingresar el número de cliente.", "warning")
        } else {
            props.setGlobalAlert("Falta validar que no eres un robot.", "warning");
        }
    }

    React.useEffect(() => {
        const objResponse = state.response_serv1
        if (objResponse) {
            if (objResponse?.code === 0) {
                setDetailsShow(objResponse)
            }
        }

        setTimeout(() => {
            setLoading(false);
        }, 3000);
    }, [state.response_serv1]);

    React.useEffect(() => {
        if (state.detailClient) {
            if (state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
                if (state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
                    setDetailClientJson(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM)

                } else {
                    setDetailClientJson([])
                    props.setGlobalAlert(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
                }
            } else {
                setDetailClientJson([])
                props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);

        }
    }, [state.detailClient])

    React.useEffect(() => {
        const shouldDisplayDealInfo =
            state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0 &&
            state.response_serv1?.code !== 0 &&
            state.response_serv1?.message !== undefined &&
            state.response_serv1?.message !== "";

        if (shouldDisplayDealInfo) {
            setDealInfo(state.response_serv1?.message)
        } else {
            setDealInfo(null);
        }

    }, [state.detailClient, state.response_serv1]);

    return (
        <>
            <CGE.Panel title={decode_utf8(props?.title_procedimiento_voluntario_colectivo)} description={decode_utf8(props?.subtitulo_procedimiento_voluntario_colectivo)} >
                <CGE.DetailClient
                    props={{
                        handleChange: (e) => {
                            setNumCli(e.target.value);
                            setDealInfo(null);
                        },
                        horizontal: true,
                        hasError: errorNumCli,
                        msgError: "Debe ingresar el Nro. de Cliente.",
                        idClient: "clientId",
                        idFormElement: "clientId",
                        labelName: "Número de Cliente:",
                        mandatoryElement: true,
                        placeholder: "Ingresar el número de cliente",
                        sizeButton: "sm",
                        typeButton: "primary",
                        valuePub: numCli,
                        propsLabelInfoContent: propsLabelInfoContent
                    }}
                    propsDetail={{
                        fullNameClient: "",
                        comunaClient: detailClientJson?.COMUNA ? detailClientJson?.COMUNA : "",
                        calleClient: detailClientJson?.CALLE ? detailClientJson?.CALLE : "",
                        nCalleClient: detailClientJson?.NUMERO_CASA ? detailClientJson?.NUMERO_CASA : "",
                        dptoBlockClient: (detailClientJson?.SUPLEMENTO || detailClientJson?.PISO) ? `${detailClientJson?.SUPLEMENTO} 
                            ${detailClientJson?.PISO}` : "",
                        ctaCtoClient: detailClientJson?.CTA_CTO
                    }}
                />
                <div className="detail-client-horizontal">
                    <CGE.Spacing type="md" />
                    <CGE.FieldRecaptcha
                        horizontal={true}
                        onChange={onChangeReCaptcha}
                        sitekey={props.api_key_recaptcha}
                    />
                </div>
                <div>
                    <CGE.Button
                        className="mx-auto"
                        label="Buscar"
                        onClick={() => {
                            handleClick();
                        }}
                    />
                </div>
                <CGE.Spacing type="nl" />
                {dealInfo || detailShow?.detalle?.length > 0 ?
                    <div className="cge-text">
                        <p className="p-normal"><strong>Número de cliente: </strong>{state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM.CTA_CTO}</p>
                        <p className="p-normal"><strong>Dirección de suministro: </strong>{`${state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM.COMUNA}, ${state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM.CALLE} ${state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM.NUMERO_CASA}`}</p>
                    </div>
                    : null}
                {dealInfo ?
                    <CGE.Text
                        text={dealInfo}
                        className="text-center border border-primary rounded p-2"
                    />
                    : null}
                {detailShow?.detalle?.length > 0 &&
                    <table id="tableDetail" className="detail-client-horizontal">
                        <tr>
                            <th>Detalle Compensación</th>
                            <th>Monto</th>
                        </tr>
                        {detailShow?.detalle.map((obj) => {
                            return <tr>
                                <td>{obj.detalle}</td>
                                <td>{changeCurrancyFormat(obj.monto, true)}</td>
                            </tr>
                        })}
                        <tr>
                            <td><b>Monto total a compensar</b></td>
                            <td><b>{changeCurrancyFormat(detailShow.montoTotal, true)}</b></td>
                        </tr>
                    </table>
                }
            </CGE.Panel>
            {loading && <Loading />}
        </>
    );
};

const FormVoluntaryCollectiveProcedureWithProvider = ({ props }) => (
    <FormVoluntaryCollectiveProcedureContextProvider>
        <FormVoluntaryCollectiveProcedure props={props} />
    </FormVoluntaryCollectiveProcedureContextProvider>
);
export default FormVoluntaryCollectiveProcedureWithProvider;
